var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interactive-button/history"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09433 10.6213H0.891602L3.00007 13.815L5.10854 10.6213H4.11842C4.77178 6.86004 8.05193 4 12.0001 4C16.4183 4 20.0001 7.58172 20.0001 12C20.0001 16.4183 16.4183 20 12.0001 20C9.21841 20 6.76772 18.5811 5.33281 16.423L3.66734 17.5304C5.45719 20.2223 8.52082 22 12.0001 22C17.5229 22 22.0001 17.5228 22.0001 12C22.0001 6.47715 17.5229 2 12.0001 2C6.94498 2 2.76595 5.75089 2.09433 10.6213ZM12.5001 12V8.5H10.5001V14H16.0001V12H12.5001Z",
    fill: "#AFAFAF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.2b440a3c363de850948c13e8a7f3fe7e.svg";
export { ForwardRef as ReactComponent };